import { render, staticRenderFns } from "./TermsAndAgreement.vue?vue&type=template&id=246e290e&scoped=true&"
import script from "./TermsAndAgreement.vue?vue&type=script&lang=js&"
export * from "./TermsAndAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndAgreement.vue?vue&type=style&index=0&id=246e290e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e290e",
  null
  
)

export default component.exports